import { useMemo } from 'react';

import { DateAddedIcon, DateListenedIcon, NameIcon } from 'assets/icons/library/SortIcons';
import { useTranslation } from 'hooks/useTypedTranslation';

import { SelectOption } from '../types/item';

export enum LibrarySortBy {
  ALPHABETICAL = 'ALPHABETICAL',
  DATE_ADDED = 'DATE_ADDED',
  RECENTLY_LISTENED = 'RECENTLY_LISTENED'
}

export enum LibrarySortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export const useSortOptions = (): SelectOption<LibrarySortBy>[] => {
  const { t } = useTranslation('common');

  return useMemo(
    () => [
      { value: LibrarySortBy.DATE_ADDED, label: t('Date Added')!, icon: <DateAddedIcon className="text-icn-txt-sec" /> },
      { value: LibrarySortBy.RECENTLY_LISTENED, label: t('Date Listened')!, icon: <DateListenedIcon className="text-icn-txt-sec" /> },
      { value: LibrarySortBy.ALPHABETICAL, label: t('Alphabetical')!, icon: <NameIcon className="text-icn-txt-sec" /> }
    ],
    [t]
  );
};

export type SortState = Record<LibrarySortBy, LibrarySortOrder | null>;
